import React from 'react';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import '../../product-overview.scss';

export const ProductOverviewAccordionTitleComponent = () => {
  return (
    <>
      <h3 className="product-details-accordion-header">Product Details</h3>
    </>
  );
};

ProductOverviewAccordionTitleComponent.displayName = 'ProductOverviewAccordionTitleComponent';

const DynamicComponent = withDynamicComponent(ProductOverviewAccordionTitleComponent);
const ProductOverviewAccordionTitle = withErrorBoundary(DynamicComponent);

ProductOverviewAccordionTitle.displayName = 'ProductOverviewAccordionTitle';

export { ProductOverviewAccordionTitle };
